import React, { useMemo, useState } from "react";
import {
  Button,
  Checkbox,
  Input,
  InputNumber,
  Modal,
  Popover,
  Radio,
  Select,
  Slider,
  Table,
  Tooltip,
} from "antd";
import { SearchOutlined, FilterOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import NoGraphData from "../workspace/DisplayChart/NoGraphData";
import { isString } from "@microsoft/applicationinsights-core-js";
import { isNumber } from "highcharts";
import isEqual from "react-fast-compare";
import config1 from "../../config";
import { useEffect } from "react";
import useDebounce from "../layout/WelcomePage/Worksheets/useDebounce";
import deepLinkIcon from "../../assets/deepLink_Icon.svg";
import Login from "../../assets/current_status/Login.svg";
import Logout from "../../assets/current_status/Logout.svg";
import OnBreak from "../../assets/current_status/OnBreak.svg";
import Assignment_Paused from "../../assets/current_status/AssignmentPaused.svg";
import Return_From_Break from "../../assets/current_status/ReturnFromBreak.svg";
import Assignment_Resumed from "../../assets/current_status/AssignmentResumed.svg";
import { SecondstoHumanReadable } from "../utils/charts/HighCharts/graphFunction";
import {
  setRealtimeFiltersObj,
  setRealtimeFinalFilters,
} from "../../redux/actions/dashboard/dashboard";
import moment from "moment";
import { getTrendsData } from "../../redux/actions/ApiCall";
import {
  getPaneIndex,
  getWindowLocationPath,
  useQuery,
} from "../../redux/constants";
import { setShareTemplateData } from "../../redux/actions/ApiCall/apiCall";
import { setIsTicketTrandsView } from "../../redux/actions/dashboard/Tab1";
const { Column } = Table;

const RealtimeGrid = ({
  tableColumns,
  dataSource,
  colors,
  PdfDownloadStatus,
  metadata,
  noteExist,
  insightsExist,
  grand_total,
  section_index,
  widget_index,
  preview,
}) => {
  const dispatch = useDispatch();
  let query = useQuery();
  const [scrollAbleTable, setScrollAbleTable] = useState(0);
  const [pdfView, setPdfView] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const [deepLinkModal, setDeepLinkModal] = useState({
    url: null,
    modalShow: false,
  });
  const authParams = useSelector((state) => state.Authentication.authParams);
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  const panes = useSelector((state) => state?.Tab1?.panes);
  const Section = useSelector((state) => state.Section.addSection);
  const shareBrands = useSelector((state) => state.ApiCall.shareBrands);
  const shareTemplateData = useSelector(
    (state) => state.ApiCall.shareTemplateData
  );
  const shareableLinkDeepDiveStatus = useSelector(
    (state) => state.ApiCall.shareableLinkDeepDiveStatus
  );
  const realtimeFiltersObj = useSelector(
    (state) => state.dashboard.realtimeFiltersObj
  );
  const realtimeFinalFilters = useSelector(
    (state) => state.dashboard.realtimeFinalFilters
  );
  const [filterObject, setFilterObject] = useState({
    pagination: { current_page: 1 },
    user_name: { filterArray: [], visible: false },
    current_status: { filterArray: [], visible: false },
    status_duration: { filterArray: [], visible: false },
    tickets_in_queue: { filterArray: [], visible: false },
    unactioned_queue: { filterArray: [], visible: false },
    oldest_ticket_since: {
      filterArray: [],
      visible: false,
      inputVal: 0,
      selectedVal: "days",
    },
  });
  const [finalFilters, setFinalFilters] = useState({
    user_name: { value: false },
    current_status: { value: false },
    status_duration: { value: false },
    tickets_in_queue: { value: false },
    unactioned_queue: { value: false },
    oldest_ticket_since: { value: false },
  });

  //mapping for status duration filter
  const status_duration_map = {
    300: "5 mins",
    600: "10 mins",
    900: "15 mins",
    1800: "30 mins",
    3600: "1 hour",
  };

  //mapping for oldest ticket since filter
  const oldest_ticket_map = {
    1800: "30 mins",
    3600: "1 hour",
    7200: "2 hours",
    18000: "5 hours",
  };

  //mapping for current status column
  const current_status_map = {
    STATUS: {
      0: "Logged In",
      1: "Logged Out",
      2: "On Break",
      3: "Returned From Break",
      6: "Assignment Paused",
      7: "Assignment Resumed",
    },
    COLOR: {
      0: "#185EDF",
      1: "#FF5D4F",
      2: "#DEAA0C",
      3: "#2D3E5C",
      6: "#AC52FF",
      7: "#5ED142",
    },
    ICON: {
      0: Login,
      1: Logout,
      2: OnBreak,
      3: Return_From_Break,
      6: Assignment_Paused,
      7: Assignment_Resumed,
    },
  };

  useEffect(() => {
    if (realtimeFinalFilters) {
      let index = getPaneIndex(panes, activeKey);
      let path = getWindowLocationPath();
      let shareSections = shareTemplateData?.section
        ? shareTemplateData?.section?.[0]
        : shareTemplateData?.sections?.[section_index];
      let section_metadata = ["create-dashboard", "edit-dashboard"]?.includes(
        path
      )
        ? section_index >= 0 && section_index !== null
          ? Section?.[section_index]
          : Section?.[0]
        : shareBrands
        ? shareSections
        : section_index >= 0
        ? panes[index]?.sections?.[section_index]
        : panes[index]?.section?.[0];
      let widget_metadata = ["create-dashboard", "edit-dashboard"]?.includes(
        path
      )
        ? section_index >= 0 && section_index !== null
          ? Section?.[section_index]?.data?.[widget_index]
          : Section?.[0]?.data?.[widget_index]
        : shareBrands
        ? shareSections?.widgets?.[widget_index]
        : section_index >= 0
        ? panes[index]?.sections?.[section_index]?.widgets?.[widget_index]
        : panes[index]?.section?.[0]?.widgets?.[widget_index];
      let widgetId = widget_metadata?.parentId
        ? widget_metadata?.parentId
        : widget_metadata?.childId
        ? widget_metadata?.childId
        : widget_metadata?.widget_id;
      let idContainer = {
        section_index: section_index >= 0 ? section_index : 0,
        widget_index: widget_index,
        template_id: shareBrands
          ? shareTemplateData?.template_id
          : panes[index]?.template_id,
        widget_id: widgetId,
        section_id:
          ["create-dashboard", "edit-dashboard"]?.includes(path) &&
          section_metadata?.id
            ? section_metadata?.id
            : section_metadata?.section_id,
      };
      let updatedWidgetId =
        idContainer?.widget_id + "#" + idContainer?.widget_index;
      if (
        realtimeFinalFilters?.[idContainer?.template_id]?.[
          idContainer?.section_id
        ]?.[updatedWidgetId]
      ) {
        setFinalFilters(
          realtimeFinalFilters?.[idContainer?.template_id]?.[
            idContainer?.section_id
          ]?.[updatedWidgetId]
        );
      }
    }
  }, [realtimeFinalFilters]);
  useEffect(() => {
    if (realtimeFiltersObj) {
      let index = getPaneIndex(panes, activeKey);
      let path = getWindowLocationPath();
      let shareSections = shareTemplateData?.section
        ? shareTemplateData?.section?.[0]
        : shareTemplateData?.sections?.[section_index];
      let section_metadata = ["create-dashboard", "edit-dashboard"]?.includes(
        path
      )
        ? section_index >= 0 && section_index !== null
          ? Section?.[section_index]
          : Section?.[0]
        : shareBrands
        ? shareSections
        : section_index >= 0
        ? panes[index]?.sections?.[section_index]
        : panes[index]?.section?.[0];
      let widget_metadata = ["create-dashboard", "edit-dashboard"]?.includes(
        path
      )
        ? section_index >= 0 && section_index !== null
          ? Section?.[section_index]?.data?.[widget_index]
          : Section?.[0]?.data?.[widget_index]
        : shareBrands
        ? shareSections?.widgets?.[widget_index]
        : section_index >= 0
        ? panes[index]?.sections?.[section_index]?.widgets?.[widget_index]
        : panes[index]?.section?.[0]?.widgets?.[widget_index];
      let widgetId = widget_metadata?.parentId
        ? widget_metadata?.parentId
        : widget_metadata?.childId
        ? widget_metadata?.childId
        : widget_metadata?.widget_id;
      let idContainer = {
        section_index: section_index >= 0 ? section_index : 0,
        widget_index: widget_index,
        template_id: shareBrands
          ? shareTemplateData?.template_id
          : panes[index]?.template_id,
        widget_id: widgetId,
        section_id:
          ["create-dashboard", "edit-dashboard"]?.includes(path) &&
          section_metadata?.id
            ? section_metadata?.id
            : section_metadata?.section_id,
      };
      let updatedWidgetId =
        idContainer?.widget_id + "#" + idContainer?.widget_index;
      if (
        realtimeFiltersObj?.[idContainer?.template_id]?.[
          idContainer?.section_id
        ]?.[updatedWidgetId]
      ) {
        setFilterObject(
          realtimeFiltersObj?.[idContainer?.template_id]?.[
            idContainer?.section_id
          ]?.[updatedWidgetId]
        );
      }
    }
  }, [realtimeFiltersObj]);

  //function to return column value
  const getTableColumnsWithSorting = (columns) => {
    columns = columns?.map((column, i) => {
      if (column?.children?.length) {
        setPdfView(true);
        column.children = getTableColumnsWithSorting(column?.children);
      } else {
        column.key = column?.title + "_" + i;
        if (column.column_key === "OldestTicketID") {
        } else
          column.sorter = (a, b) => {
            if (a[column?.dataIndex]) {
              if (
                isString(a[column?.dataIndex]) &&
                isString(b[column?.dataIndex])
              ) {
                if ((a?.total_flag || b?.total_flag) && grand_total) return 0;
                else
                  return a[column?.dataIndex]?.localeCompare(
                    b[column?.dataIndex]
                  );
              } else if (
                (isString(a[column?.dataIndex]) &&
                  isNumber(b[column?.dataIndex])) ||
                (isNumber(a[column?.dataIndex]) &&
                  isString(b[column?.dataIndex]))
              ) {
                if ((a?.total_flag || b?.total_flag) && grand_total) return 0;
                else
                  return isString(a[column?.dataIndex]) &&
                    isNumber(b[column?.dataIndex])
                    ? -1
                    : 1;
              } else {
                if ((a?.total_flag || b?.total_flag) && grand_total) return 0;
                else return a[column?.dataIndex] - b[column?.dataIndex];
              }
            } else {
              if (isString(a[column?.title]) && isString(b[column?.title])) {
                if ((a?.total_flag || b?.total_flag) && grand_total) return 0;
                else return a[column?.title]?.localeCompare(b[column?.title]);
              } else if (
                (isString(a[column?.title]) && isNumber(b[column?.title])) ||
                (isNumber(a[column?.title]) && isString(b[column?.title]))
              ) {
                if ((a?.total_flag || b?.total_flag) && grand_total) return 0;
                else
                  return isString(a[column?.title]) &&
                    isNumber(b[column?.title])
                    ? -1
                    : 1;
              } else {
                if ((a?.total_flag || b?.total_flag) && grand_total) return 0;
                else return a[column?.title] - b[column?.title];
              }
            }
          };
      }
      return column;
    });
    return columns;
  };
  //function to be used for user name and current status column filters
  const onCheckboxChange = (e, type) => {
    let index = getPaneIndex(panes, activeKey);
    let path = getWindowLocationPath();
    let shareSections = shareTemplateData?.section
      ? shareTemplateData?.section?.[0]
      : shareTemplateData?.sections?.[section_index];
    let section_metadata = ["create-dashboard", "edit-dashboard"]?.includes(
      path
    )
      ? section_index >= 0 && section_index !== null
        ? Section?.[section_index]
        : Section?.[0]
      : shareBrands
      ? shareSections
      : section_index >= 0
      ? panes[index]?.sections?.[section_index]
      : panes[index]?.section?.[0];
    let widget_metadata = ["create-dashboard", "edit-dashboard"]?.includes(path)
      ? section_index >= 0 && section_index !== null
        ? Section?.[section_index]?.data?.[widget_index]
        : Section?.[0]?.data?.[widget_index]
      : shareBrands
      ? shareSections?.widgets?.[widget_index]
      : section_index >= 0
      ? panes[index]?.sections?.[section_index]?.widgets?.[widget_index]
      : panes[index]?.section?.[0]?.widgets?.[widget_index];
    let widgetId = widget_metadata?.parentId
      ? widget_metadata?.parentId
      : widget_metadata?.childId
      ? widget_metadata?.childId
      : widget_metadata?.widget_id;
    let idContainer = {
      section_index: section_index >= 0 ? section_index : 0,
      widget_index: widget_index,
      template_id: shareBrands
        ? shareTemplateData?.template_id
        : panes[index]?.template_id,
      widget_id: widgetId,
      section_id:
        ["create-dashboard", "edit-dashboard"]?.includes(path) &&
        section_metadata?.id
          ? section_metadata?.id
          : section_metadata?.section_id,
    };

    let updatefiltersObj = { ...filterObject };
    let updateFilterArray = [...updatefiltersObj?.[type]?.filterArray];
    if (e?.target?.checked) {
      //filter out value if it already exist
      updateFilterArray = updateFilterArray?.filter(
        (el) => el !== e?.target?.value
      );
      //push the current value
      updateFilterArray.push(e?.target?.value);
    }
    if (!e?.target?.checked) {
      updateFilterArray = updateFilterArray?.filter(
        (el) => el !== e?.target?.value
      );
    }

    updatefiltersObj[type].filterArray = updateFilterArray;
    dispatch(
      setRealtimeFiltersObj(updatefiltersObj, realtimeFiltersObj, idContainer)
    );
  };
  //function to be used for status duration column filters
  const onRadioChange = (e, type) => {
    let index = getPaneIndex(panes, activeKey);
    let path = getWindowLocationPath();
    let shareSections = shareTemplateData?.section
      ? shareTemplateData?.section?.[0]
      : shareTemplateData?.sections?.[section_index];
    let section_metadata = ["create-dashboard", "edit-dashboard"]?.includes(
      path
    )
      ? section_index >= 0 && section_index !== null
        ? Section?.[section_index]
        : Section?.[0]
      : shareBrands
      ? shareSections
      : section_index >= 0
      ? panes[index]?.sections?.[section_index]
      : panes[index]?.section?.[0];
    let widget_metadata = ["create-dashboard", "edit-dashboard"]?.includes(path)
      ? section_index >= 0 && section_index !== null
        ? Section?.[section_index]?.data?.[widget_index]
        : Section?.[0]?.data?.[widget_index]
      : shareBrands
      ? shareSections?.widgets?.[widget_index]
      : section_index >= 0
      ? panes[index]?.sections?.[section_index]?.widgets?.[widget_index]
      : panes[index]?.section?.[0]?.widgets?.[widget_index];
    let widgetId = widget_metadata?.parentId
      ? widget_metadata?.parentId
      : widget_metadata?.childId
      ? widget_metadata?.childId
      : widget_metadata?.widget_id;
    let idContainer = {
      section_index: section_index >= 0 ? section_index : 0,
      widget_index: widget_index,
      template_id: shareBrands
        ? shareTemplateData?.template_id
        : panes[index]?.template_id,
      widget_id: widgetId,
      section_id:
        ["create-dashboard", "edit-dashboard"]?.includes(path) &&
        section_metadata?.id
          ? section_metadata?.id
          : section_metadata?.section_id,
    };
    let updatefiltersObj = { ...filterObject };
    let updateFilterArray = [];

    updateFilterArray.push(e?.target?.value);

    updatefiltersObj[type].filterArray = updateFilterArray;
    if (type === "oldest_ticket_since") {
      updatefiltersObj[type].selectedVal = "days";
      updatefiltersObj[type].inputVal = 0;
    }
    dispatch(
      setRealtimeFiltersObj(updatefiltersObj, realtimeFiltersObj, idContainer)
    );
  };
  //function to be used for status duration column filters
  const onSelectChange = (e, type, input_type) => {
    let index = getPaneIndex(panes, activeKey);
    let path = getWindowLocationPath();
    let shareSections = shareTemplateData?.section
      ? shareTemplateData?.section?.[0]
      : shareTemplateData?.sections?.[section_index];
    let section_metadata = ["create-dashboard", "edit-dashboard"]?.includes(
      path
    )
      ? section_index >= 0 && section_index !== null
        ? Section?.[section_index]
        : Section?.[0]
      : shareBrands
      ? shareSections
      : section_index >= 0
      ? panes[index]?.sections?.[section_index]
      : panes[index]?.section?.[0];
    let widget_metadata = ["create-dashboard", "edit-dashboard"]?.includes(path)
      ? section_index >= 0 && section_index !== null
        ? Section?.[section_index]?.data?.[widget_index]
        : Section?.[0]?.data?.[widget_index]
      : shareBrands
      ? shareSections?.widgets?.[widget_index]
      : section_index >= 0
      ? panes[index]?.sections?.[section_index]?.widgets?.[widget_index]
      : panes[index]?.section?.[0]?.widgets?.[widget_index];
    let widgetId = widget_metadata?.parentId
      ? widget_metadata?.parentId
      : widget_metadata?.childId
      ? widget_metadata?.childId
      : widget_metadata?.widget_id;
    let idContainer = {
      section_index: section_index >= 0 ? section_index : 0,
      widget_index: widget_index,
      template_id: shareBrands
        ? shareTemplateData?.template_id
        : panes[index]?.template_id,
      widget_id: widgetId,
      section_id:
        ["create-dashboard", "edit-dashboard"]?.includes(path) &&
        section_metadata?.id
          ? section_metadata?.id
          : section_metadata?.section_id,
    };

    let updatefiltersObj = { ...filterObject };
    let updateFilterArray = [];
    let duration_in_seconds;

    if (input_type === "select") {
      updatefiltersObj[type].selectedVal = e;
      duration_in_seconds = moment
        .duration(updatefiltersObj?.[type]?.inputVal, e)
        .asSeconds();
      if (!updatefiltersObj?.[type]?.inputVal) {
        updatefiltersObj[type].inputVal = 0;
      }
    } else if (input_type === "int") {
      updatefiltersObj[type].inputVal = e;
      duration_in_seconds = moment
        .duration(e, updatefiltersObj[type]?.selectedVal)
        .asSeconds();
      if (!updatefiltersObj?.[type]?.selectedVal) {
        updatefiltersObj[type].selectedVal = "days";
      }
    }

    updateFilterArray.push(duration_in_seconds);
    updatefiltersObj[type].filterArray = updateFilterArray;
    dispatch(
      setRealtimeFiltersObj(updatefiltersObj, realtimeFiltersObj, idContainer)
    );
  };
  //function to be used for ticket in queue and unactioned queue column filters
  const onIntChange = (value, type, int_type) => {
    let index = getPaneIndex(panes, activeKey);
    let path = getWindowLocationPath();
    let shareSections = shareTemplateData?.section
      ? shareTemplateData?.section?.[0]
      : shareTemplateData?.sections?.[section_index];
    let section_metadata = ["create-dashboard", "edit-dashboard"]?.includes(
      path
    )
      ? section_index >= 0 && section_index !== null
        ? Section?.[section_index]
        : Section?.[0]
      : shareBrands
      ? shareSections
      : section_index >= 0
      ? panes[index]?.sections?.[section_index]
      : panes[index]?.section?.[0];
    let widget_metadata = ["create-dashboard", "edit-dashboard"]?.includes(path)
      ? section_index >= 0 && section_index !== null
        ? Section?.[section_index]?.data?.[widget_index]
        : Section?.[0]?.data?.[widget_index]
      : shareBrands
      ? shareSections?.widgets?.[widget_index]
      : section_index >= 0
      ? panes[index]?.sections?.[section_index]?.widgets?.[widget_index]
      : panes[index]?.section?.[0]?.widgets?.[widget_index];
    let widgetId = widget_metadata?.parentId
      ? widget_metadata?.parentId
      : widget_metadata?.childId
      ? widget_metadata?.childId
      : widget_metadata?.widget_id;
    let idContainer = {
      section_index: section_index >= 0 ? section_index : 0,
      widget_index: widget_index,
      template_id: shareBrands
        ? shareTemplateData?.template_id
        : panes[index]?.template_id,
      widget_id: widgetId,
      section_id:
        ["create-dashboard", "edit-dashboard"]?.includes(path) &&
        section_metadata?.id
          ? section_metadata?.id
          : section_metadata?.section_id,
    };

    let updatefiltersObj = { ...filterObject };
    let updateFilterArray = [...updatefiltersObj?.[type]?.filterArray];
    if (int_type === "min") {
      updateFilterArray[0] = value;
    } else if (int_type === "max") {
      updateFilterArray[1] = value;
    } else if (value?.length) {
      //slider
      updateFilterArray[0] = value?.[0];
      updateFilterArray[1] = value?.[1];
    }

    updatefiltersObj[type].filterArray = updateFilterArray;
    dispatch(
      setRealtimeFiltersObj(updatefiltersObj, realtimeFiltersObj, idContainer)
    );
  };
  //function to be used for show popover visible in all the column filters
  const onVisible = (e, type) => {
    let index = getPaneIndex(panes, activeKey);
    let path = getWindowLocationPath();
    let shareSections = shareTemplateData?.section
      ? shareTemplateData?.section?.[0]
      : shareTemplateData?.sections?.[section_index];
    let section_metadata = ["create-dashboard", "edit-dashboard"]?.includes(
      path
    )
      ? section_index >= 0 && section_index !== null
        ? Section?.[section_index]
        : Section?.[0]
      : shareBrands
      ? shareSections
      : section_index >= 0
      ? panes[index]?.sections?.[section_index]
      : panes[index]?.section?.[0];
    let widget_metadata = ["create-dashboard", "edit-dashboard"]?.includes(path)
      ? section_index >= 0 && section_index !== null
        ? Section?.[section_index]?.data?.[widget_index]
        : Section?.[0]?.data?.[widget_index]
      : shareBrands
      ? shareSections?.widgets?.[widget_index]
      : section_index >= 0
      ? panes[index]?.sections?.[section_index]?.widgets?.[widget_index]
      : panes[index]?.section?.[0]?.widgets?.[widget_index];
    let widgetId = widget_metadata?.parentId
      ? widget_metadata?.parentId
      : widget_metadata?.childId
      ? widget_metadata?.childId
      : widget_metadata?.widget_id;
    let idContainer = {
      section_index: section_index >= 0 ? section_index : 0,
      widget_index: widget_index,
      template_id: shareBrands
        ? shareTemplateData?.template_id
        : panes[index]?.template_id,
      widget_id: widgetId,
      section_id:
        ["create-dashboard", "edit-dashboard"]?.includes(path) &&
        section_metadata?.id
          ? section_metadata?.id
          : section_metadata?.section_id,
    };

    let updatefiltersObj = { ...filterObject };
    updatefiltersObj[type].visible = e === null ? true : e;
    dispatch(
      setRealtimeFiltersObj(updatefiltersObj, realtimeFiltersObj, idContainer)
    );
    // to clear search text and checked values if filter is not applied
    if (e) {
      if (!finalFilters?.[type]?.value) {
        updatefiltersObj[type].filterArray = [];
      }
      setSearchText("");
    }
  };
  //function to be used if filter button is clicked in all the column filters
  const onFilter = (type, col) => {
    let updatefiltersObj = { ...filterObject };
    let index = getPaneIndex(panes, activeKey);
    let path = getWindowLocationPath();
    let shareSections = shareTemplateData?.section
      ? shareTemplateData?.section?.[0]
      : shareTemplateData?.sections?.[section_index];
    let section_metadata = ["create-dashboard", "edit-dashboard"]?.includes(
      path
    )
      ? section_index >= 0 && section_index !== null
        ? Section?.[section_index]
        : Section?.[0]
      : shareBrands
      ? shareSections
      : section_index >= 0
      ? panes[index]?.sections?.[section_index]
      : panes[index]?.section?.[0];
    let widget_metadata = ["create-dashboard", "edit-dashboard"]?.includes(path)
      ? section_index >= 0 && section_index !== null
        ? Section?.[section_index]?.data?.[widget_index]
        : Section?.[0]?.data?.[widget_index]
      : shareBrands
      ? shareSections?.widgets?.[widget_index]
      : section_index >= 0
      ? panes[index]?.sections?.[section_index]?.widgets?.[widget_index]
      : panes[index]?.section?.[0]?.widgets?.[widget_index];
    let widgetId = widget_metadata?.parentId
      ? widget_metadata?.parentId
      : widget_metadata?.childId
      ? widget_metadata?.childId
      : widget_metadata?.widget_id;
    let idContainer = {
      section_index: section_index >= 0 ? section_index : 0,
      widget_index: widget_index,
      template_id: shareBrands
        ? shareTemplateData?.template_id
        : panes[index]?.template_id,
      widget_id: widgetId,
      section_id:
        ["create-dashboard", "edit-dashboard"]?.includes(path) &&
        section_metadata?.id
          ? section_metadata?.id
          : section_metadata?.section_id,
    };
    if (type === "user_name") {
      dispatch(
        setRealtimeFinalFilters(
          {
            ...finalFilters,
            user_name: { value: true },
          },
          realtimeFinalFilters,
          idContainer
        )
      );
    } else if (type === "current_status") {
      dispatch(
        setRealtimeFinalFilters(
          {
            ...finalFilters,
            current_status: { value: true },
          },
          realtimeFinalFilters,
          idContainer
        )
      );
    } else if (type === "status_duration") {
      dispatch(
        setRealtimeFinalFilters(
          {
            ...finalFilters,
            status_duration: { value: true },
          },
          realtimeFinalFilters,
          idContainer
        )
      );
    } else if (type === "tickets_in_queue") {
      dispatch(
        setRealtimeFinalFilters(
          {
            ...finalFilters,
            tickets_in_queue: { value: true, max: col?.max },
          },
          realtimeFinalFilters,
          idContainer
        )
      );
    } else if (type === "unactioned_queue") {
      dispatch(
        setRealtimeFinalFilters(
          {
            ...finalFilters,
            unactioned_queue: { value: true, max: col?.max },
          },
          realtimeFinalFilters,
          idContainer
        )
      );
    } else if (type === "oldest_ticket_since") {
      dispatch(
        setRealtimeFinalFilters(
          {
            ...finalFilters,
            oldest_ticket_since: { value: true },
          },
          realtimeFinalFilters,
          idContainer
        )
      );
    }
    if (updatefiltersObj?.["pagination"]?.current_page)
      updatefiltersObj["pagination"].current_page = 1;
    dispatch(
      setRealtimeFiltersObj(updatefiltersObj, realtimeFiltersObj, idContainer)
    );
  };
  //function to be used if reset button is clicked in all the column filters
  const onReset = (type) => {
    let updatefiltersObj = { ...filterObject };
    updatefiltersObj[type].filterArray = [];
    let index = getPaneIndex(panes, activeKey);
    let path = getWindowLocationPath();
    let shareSections = shareTemplateData?.section
      ? shareTemplateData?.section?.[0]
      : shareTemplateData?.sections?.[section_index];
    let section_metadata = ["create-dashboard", "edit-dashboard"]?.includes(
      path
    )
      ? section_index >= 0 && section_index !== null
        ? Section?.[section_index]
        : Section?.[0]
      : shareBrands
      ? shareSections
      : section_index >= 0
      ? panes[index]?.sections?.[section_index]
      : panes[index]?.section?.[0];
    let widget_metadata = ["create-dashboard", "edit-dashboard"]?.includes(path)
      ? section_index >= 0 && section_index !== null
        ? Section?.[section_index]?.data?.[widget_index]
        : Section?.[0]?.data?.[widget_index]
      : shareBrands
      ? shareSections?.widgets?.[widget_index]
      : section_index >= 0
      ? panes[index]?.sections?.[section_index]?.widgets?.[widget_index]
      : panes[index]?.section?.[0]?.widgets?.[widget_index];
    let widgetId = widget_metadata?.parentId
      ? widget_metadata?.parentId
      : widget_metadata?.childId
      ? widget_metadata?.childId
      : widget_metadata?.widget_id;
    let idContainer = {
      section_index: section_index >= 0 ? section_index : 0,
      widget_index: widget_index,
      template_id: shareBrands
        ? shareTemplateData?.template_id
        : panes[index]?.template_id,
      widget_id: widgetId,
      section_id:
        ["create-dashboard", "edit-dashboard"]?.includes(path) &&
        section_metadata?.id
          ? section_metadata?.id
          : section_metadata?.section_id,
    };
    if (type === "user_name") {
      dispatch(
        setRealtimeFinalFilters(
          {
            ...finalFilters,
            user_name: true,
          },
          realtimeFinalFilters,
          idContainer
        )
      );
    } else if (type === "current_status") {
      dispatch(
        setRealtimeFinalFilters(
          {
            ...finalFilters,
            current_status: true,
          },
          realtimeFinalFilters,
          idContainer
        )
      );
    } else if (type === "status_duration") {
      dispatch(
        setRealtimeFinalFilters(
          {
            ...finalFilters,
            status_duration: true,
          },
          realtimeFinalFilters,
          idContainer
        )
      );
    } else if (type === "tickets_in_queue") {
      dispatch(
        setRealtimeFinalFilters(
          {
            ...finalFilters,
            tickets_in_queue: true,
          },
          realtimeFinalFilters,
          idContainer
        )
      );
    } else if (type === "unactioned_queue") {
      dispatch(
        setRealtimeFinalFilters(
          {
            ...finalFilters,
            unactioned_queue: true,
          },
          realtimeFinalFilters,
          idContainer
        )
      );
    } else if (type === "oldest_ticket_since") {
      updatefiltersObj[type].inputVal = 0;
      updatefiltersObj[type].selectedVal = "days";
      dispatch(
        setRealtimeFinalFilters(
          {
            ...finalFilters,
            oldest_ticket_since: true,
          },
          realtimeFinalFilters,
          idContainer
        )
      );
    }
    updatefiltersObj[type].visible = false;
    dispatch(
      setRealtimeFiltersObj(updatefiltersObj, realtimeFiltersObj, idContainer)
    );
  };
  //function is used for the logic in all the column filters
  const handleFilters = (data, type) => {
    let updatefiltersObj = { ...filterObject };

    let updateDataSource1 = data;
    let index = getPaneIndex(panes, activeKey);
    let path = getWindowLocationPath();
    let shareSections = shareTemplateData?.section
      ? shareTemplateData?.section?.[0]
      : shareTemplateData?.sections?.[section_index];
    let section_metadata = ["create-dashboard", "edit-dashboard"]?.includes(
      path
    )
      ? section_index >= 0 && section_index !== null
        ? Section?.[section_index]
        : Section?.[0]
      : shareBrands
      ? shareSections
      : section_index >= 0
      ? panes[index]?.sections?.[section_index]
      : panes[index]?.section?.[0];
    let widget_metadata = ["create-dashboard", "edit-dashboard"]?.includes(path)
      ? section_index >= 0 && section_index !== null
        ? Section?.[section_index]?.data?.[widget_index]
        : Section?.[0]?.data?.[widget_index]
      : shareBrands
      ? shareSections?.widgets?.[widget_index]
      : section_index >= 0
      ? panes[index]?.sections?.[section_index]?.widgets?.[widget_index]
      : panes[index]?.section?.[0]?.widgets?.[widget_index];
    let widgetId = widget_metadata?.parentId
      ? widget_metadata?.parentId
      : widget_metadata?.childId
      ? widget_metadata?.childId
      : widget_metadata?.widget_id;
    let idContainer = {
      section_index: section_index >= 0 ? section_index : 0,
      widget_index: widget_index,
      template_id: shareBrands
        ? shareTemplateData?.template_id
        : panes[index]?.template_id,
      widget_id: widgetId,
      section_id:
        ["create-dashboard", "edit-dashboard"]?.includes(path) &&
        section_metadata?.id
          ? section_metadata?.id
          : section_metadata?.section_id,
    };
    if (type === "user_name") {
      if (updatefiltersObj?.[type]?.filterArray?.length > 0) {
        updateDataSource1 = updateDataSource1.filter((el, i) => {
          if (
            updatefiltersObj?.[type]?.filterArray?.includes(
              el?.["Agent"]?.toString()
            )
          ) {
            return el;
          }
        });
      } else {
        dispatch(
          setRealtimeFinalFilters(
            {
              ...finalFilters,
              user_name: false,
            },
            realtimeFinalFilters,
            idContainer
          )
        );
      }
    }
    if (type === "current_status") {
      if (updatefiltersObj?.[type]?.filterArray?.length > 0) {
        updateDataSource1 = updateDataSource1.filter((el, i) => {
          if (
            updatefiltersObj?.[type]?.filterArray?.includes(
              el?.["Current Status"]?.toString()
            )
          ) {
            return el;
          }
        });
      } else {
        dispatch(
          setRealtimeFinalFilters(
            {
              ...finalFilters,
              current_status: false,
            },
            realtimeFinalFilters,
            idContainer
          )
        );
      }
    } else if (type === "status_duration") {
      if (updatefiltersObj?.[type]?.filterArray?.length > 0) {
        updateDataSource1 = updateDataSource1.filter((el, i) => {
          if (
            el?.["Status Updated Since"] >
            updatefiltersObj?.[type]?.filterArray?.[0]
          ) {
            return el;
          }
        });
      } else {
        dispatch(
          setRealtimeFinalFilters(
            {
              ...finalFilters,
              status_duration: false,
            },
            realtimeFinalFilters,
            idContainer
          )
        );
      }
    } else if (type === "tickets_in_queue") {
      if (updatefiltersObj?.[type]?.filterArray?.length > 0) {
        let min = updatefiltersObj?.[type]?.filterArray?.[0]
          ? parseInt(updatefiltersObj?.[type]?.filterArray?.[0])
          : 0;
        let max = updatefiltersObj?.[type]?.filterArray?.[1]
          ? parseInt(updatefiltersObj?.[type]?.filterArray?.[1])
          : parseInt(finalFilters?.[type]?.max);

        updateDataSource1 = updateDataSource1.filter((el, i) => {
          if (
            el?.["Tickets in queue"] >= min &&
            el?.["Tickets in queue"] <= max
          ) {
            return el;
          }
        });
      } else {
        dispatch(
          setRealtimeFinalFilters(
            {
              ...finalFilters,
              tickets_in_queue: false,
            },
            realtimeFinalFilters,
            idContainer
          )
        );
      }
    } else if (type === "unactioned_queue") {
      let min = updatefiltersObj?.[type]?.filterArray?.[0]
        ? parseInt(updatefiltersObj?.[type]?.filterArray?.[0])
        : 0;
      let max = updatefiltersObj?.[type]?.filterArray?.[1]
        ? parseInt(updatefiltersObj?.[type]?.filterArray?.[1])
        : parseInt(finalFilters?.[type]?.max);
      if (updatefiltersObj?.[type]?.filterArray?.length > 0) {
        updateDataSource1 = updateDataSource1.filter((el, i) => {
          if (
            el?.["Unactioned Tickets in queue"] >= min &&
            el?.["Unactioned Tickets in queue"] <= max
          ) {
            return el;
          }
        });
      } else {
        dispatch(
          setRealtimeFinalFilters(
            {
              ...finalFilters,
              unactioned_queue: false,
            },
            realtimeFinalFilters,
            idContainer
          )
        );
      }
    } else if (type === "oldest_ticket_since") {
      if (updatefiltersObj?.[type]?.filterArray?.length > 0) {
        updateDataSource1 = updateDataSource1.filter((el, i) => {
          if (
            el?.["Oldest Ticket Since"] >
            updatefiltersObj?.[type]?.filterArray?.[0]
          ) {
            return el;
          }
        });
      } else {
        dispatch(
          setRealtimeFinalFilters(
            {
              ...finalFilters,
              oldest_ticket_since: false,
            },
            realtimeFinalFilters,
            idContainer
          )
        );
      }
    }
    updatefiltersObj[type].visible = false;
    dispatch(
      setRealtimeFiltersObj(updatefiltersObj, realtimeFiltersObj, idContainer)
    );
    return updateDataSource1;
  };
  //function is used to return the updated data source
  const getUpdatedDataSource = (type) => {
    let update_data_source = dataSource;

    if (finalFilters?.user_name?.value) {
      update_data_source = handleFilters(update_data_source, "user_name");
    }
    if (finalFilters?.current_status?.value) {
      update_data_source = handleFilters(update_data_source, "current_status");
    }
    if (finalFilters?.status_duration?.value) {
      update_data_source = handleFilters(update_data_source, "status_duration");
    }
    if (finalFilters?.tickets_in_queue?.value) {
      update_data_source = handleFilters(
        update_data_source,
        "tickets_in_queue"
      );
    }
    if (finalFilters?.unactioned_queue?.value) {
      update_data_source = handleFilters(
        update_data_source,
        "unactioned_queue"
      );
    }
    if (finalFilters?.oldest_ticket_since?.value) {
      update_data_source = handleFilters(
        update_data_source,
        "oldest_ticket_since"
      );
    }

    return update_data_source;
  };
  const updatedataSource = useMemo(
    () => getUpdatedDataSource(),
    [dataSource, PdfDownloadStatus, finalFilters]
  );
  const updatedTableColumn = useMemo(
    () => getTableColumnsWithSorting(tableColumns),
    [tableColumns]
  );
  const onExternal = (TicketID, PostBrandID) => {
    setDeepLinkModal({
      url: null,
      modalShow: true,
    });
    let url =
      config1?.config1?.app_id === "10" || config1?.config1?.app_id === 10
        ? "https://preprodcx.locobuzz.com/ticketDetail"
        : config1?.config1?.app_id === "6" || config1?.config1?.app_id === 6
        ? window?.location?.origin?.includes("bbps.locobuzz.com") ||
          window?.location?.ancestorOrigins?.[0]?.includes("bbps.locobuzz.com")
          ? "https://bbps.locobuzz.com/ticketDetail"
          : "https://cx.locobuzz.com/ticketDetail"
        : "https://cx.locobuzz.com/ticketDetail";
    // : "https://demo.locobuzz.com/ticketDetail";

    let finalUrl = `${url}/${TicketID}/${PostBrandID}`;
    if (config1?.config1?.app_id === "2") {
      console.log("Deep Link URL =>", finalUrl);
    }

    //window.open(finalUrl);

    setDeepLinkModal({
      url: (
        <iframe
          title="Ticket Details"
          allowfullscreen={true}
          src={finalUrl}
          alt="Ticket Details"
          className="w-100 border-0 border-radius-4"
          sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
          style={{ height: "calc(100vh - 6.3rem)", marginTop: "3.7rem" }}
        />
      ),
      modalShow: true,
    });
  };
  const handleDeepLinkOk = () => {
    setDeepLinkModal({
      url: null,
      modalShow: false,
    });
  };
  const handleDeepLinkCancel = () => {
    setDeepLinkModal({
      url: null,
      modalShow: false,
    });
  };
  const handlePagination = (e, type) => {
    let index = getPaneIndex(panes, activeKey);
    let path = getWindowLocationPath();
    let shareSections = shareTemplateData?.section
      ? shareTemplateData?.section?.[0]
      : shareTemplateData?.sections?.[section_index];
    let section_metadata = ["create-dashboard", "edit-dashboard"]?.includes(
      path
    )
      ? section_index >= 0 && section_index !== null
        ? Section?.[section_index]
        : Section?.[0]
      : shareBrands
      ? shareSections
      : section_index >= 0
      ? panes[index]?.sections?.[section_index]
      : panes[index]?.section?.[0];
    let widget_metadata = ["create-dashboard", "edit-dashboard"]?.includes(path)
      ? section_index >= 0 && section_index !== null
        ? Section?.[section_index]?.data?.[widget_index]
        : Section?.[0]?.data?.[widget_index]
      : shareBrands
      ? shareSections?.widgets?.[widget_index]
      : section_index >= 0
      ? panes[index]?.sections?.[section_index]?.widgets?.[widget_index]
      : panes[index]?.section?.[0]?.widgets?.[widget_index];
    let widgetId = widget_metadata?.parentId
      ? widget_metadata?.parentId
      : widget_metadata?.childId
      ? widget_metadata?.childId
      : widget_metadata?.widget_id;
    let idContainer = {
      section_index: section_index >= 0 ? section_index : 0,
      widget_index: widget_index,
      template_id: shareBrands
        ? shareTemplateData?.template_id
        : panes[index]?.template_id,
      widget_id: widgetId,
      section_id:
        ["create-dashboard", "edit-dashboard"]?.includes(path) &&
        section_metadata?.id
          ? section_metadata?.id
          : section_metadata?.section_id,
    };

    let updatefiltersObj = { ...filterObject };
    setScrollAbleTable(e?.pageSize);
    setPageSize(e?.pageSize);

    if (updatefiltersObj?.[type]?.current_page) {
      updatefiltersObj[type].current_page = e?.current;
    }
    dispatch(
      setRealtimeFiltersObj(updatefiltersObj, realtimeFiltersObj, idContainer)
    );
  };
  const handleShowTreands = (d) => {
    let index = getPaneIndex(panes, activeKey);
    // let shareSections = shareTemplateData?.section
    //   ? shareTemplateData?.section?.[0]
    //   : shareTemplateData?.sections?.[section_index];
    // let widget_metadata = shareBrands
    //   ? shareSections?.widgets?.[widget_index]
    //   : section_index >= 0
    //   ? panes[index]?.sections?.[section_index]?.widgets?.[widget_index]
    //   : panes[index]?.section?.[0]?.widgets?.[widget_index];

    let payloadObj;
    if (!shareBrands) {
      dispatch(setIsTicketTrandsView(true, panes, index));
      let body = {
        brand_id: d?.["Brand ID"] ? d?.["Brand ID"] : null,
        brand_name: d?.["Brand Name"] ? d?.["Brand Name"] : null,
        end_date: metadata?.payload?.end_date,
        ptoken: metadata?.payload?.ptoken,
      };
      payloadObj = {
        body: body,
        teamUserId: d?.["Team User ID"] ? d?.["Team User ID"] : null,
        payload: true,
      };
      authParams && dispatch(getTrendsData(payloadObj));
    } else {
      shareTemplateData &&
        dispatch(
          setShareTemplateData({
            ...shareTemplateData,
            isTicketTrandsView: true,
          })
        );
      let body = {
        brand_id: d?.["Brand ID"] ? d?.["Brand ID"] : null,
        brand_name: d?.["Brand Name"] ? d?.["Brand Name"] : null,
        end_date: metadata?.payload?.end_date,
        share_id: query?.get("share_id"),
      };
      payloadObj = {
        body: body,
        teamUserId: d?.["Team User ID"] ? d?.["Team User ID"] : null,
        payload: true,
      };
      dispatch(getTrendsData(payloadObj));
    }
  };
  return updatedTableColumn ? (
    <div
      id={`table_${metadata?.widget_id}`}
      className="widgetmaker-grid-chart p-15 w-100"
    >
      <Table
        dataSource={updatedataSource}
        className="custom_table_scroll"
        scroll={{
          x: "max-content",
          //y: scrollAbleTable > 10 ? 681 : undefined,
        }}
        onChange={(e) => handlePagination(e, "pagination")}
        pagination={
          PdfDownloadStatus
            ? false
            : {
                current: filterObject?.["pagination"]?.current_page,
                hideOnSinglePage: updatedataSource?.length > 10 ? false : true,
                defaultPageSize: 10,
                showSizeChanger: metadata?.span === "one_third" ? false : true,
                pageSize: pageSize,
                // pageSizeOptions:
                //   updatedataSource?.length > 10 &&
                //   updatedataSource?.length <= 20
                //     ? ["10", "20"]
                //     : updatedataSource?.length > 20 &&
                //       updatedataSource?.length <= 30
                //     ? ["10", "20", "30"]
                //     : updatedataSource?.length > 30 &&
                //       updatedataSource?.length <= 40
                //     ? ["10", "20", "30", "40"]
                //     : ["10", "20", "30", "40", "50"],
                locale: { items_per_page: "" },
                total: updatedataSource?.length,
                showTotal: (total, range) =>
                  `${range[0]}-${range[1]} of ${total}`,
              }
        }
      >
        {/* ${metadata?.show_marker ? '':''} */}
        {updatedTableColumn?.map((col, i) => {
          if (
            // ![
            //   "BrandID_OldestTicket",
            //   "BrandName",
            //   //"BrandFriendlyName",
            //   "UserID",
            // ]?.includes(col?.column_key) &&
            !metadata?.chart?.chart_settings?.hide_columns?.includes(col?.title)
          )
            return (
              <Column
                width={
                  PdfDownloadStatus ? "" : `${col?.title?.length * 8.5 + 51}px`
                }
                title={(value) => {
                  return colors?.length && colors[i] !== "#000000" ? (
                    <span
                      style={{
                        color:
                          colors && colors[i] !== "#000000" ? colors[i] : "",
                      }}
                      className="d-inline-block"
                    >
                      <span>{col?.title} </span>
                    </span>
                  ) : (
                    <span
                      className={`${
                        col?.column_key === "OldestTicketID"
                          ? ""
                          : "d-flex align-items-center "
                      }  `}
                      onClick={(e) => {
                        e.stopPropagation();
                        e.nativeEvent?.stopImmediatePropagation();
                      }}
                    >
                      <span
                        style={{
                          width:
                            col?.column_key === "UserName"
                              ? "16rem"
                              : col?.column_key === "CurrentLogInStatus"
                              ? "13rem"
                              : "",
                        }}
                      >
                        {col?.title}
                      </span>
                      {col?.column_key === "UserName" && (
                        <Popover
                          content={
                            <div className="p-15" style={{ maxWidth: "25rem" }}>
                              <div className="floating-label-group header-brands mt-1">
                                <Input
                                  //placeholder={`Search ${dataIndex}`}
                                  maxLength={50}
                                  value={searchText}
                                  onChange={(e) =>
                                    setSearchText(e.target.value)
                                  }
                                  style={{ marginBottom: 8, display: "block" }}
                                />
                                <label
                                  className="portlet-label floating-label"
                                  style={{ top: "-1rem" }}
                                >
                                  Search
                                </label>
                                <span
                                  style={{ bottom: "-0.5rem", right: "0.5rem" }}
                                  className="text-gray position-absolute font-size12"
                                >
                                  {searchText?.length}/50
                                </span>
                              </div>
                              <div
                                className="custom_scroll1 "
                                style={{
                                  maxHeight: "15.5rem",

                                  overflow: "auto",
                                }}
                              >
                                {dataSource?.map((el) => {
                                  if (
                                    (searchText !== "" &&
                                      el?.["Agent"]
                                        ?.toLowerCase()
                                        ?.includes(
                                          searchText?.toLowerCase()
                                        )) ||
                                    searchText === ""
                                  )
                                    return (
                                      <div>
                                        <Checkbox
                                          onChange={(e) =>
                                            onCheckboxChange(e, "user_name")
                                          }
                                          checked={filterObject?.[
                                            "user_name"
                                          ]?.filterArray?.includes(
                                            el?.["Agent"]
                                          )}
                                          value={el?.["Agent"]}
                                        >
                                          <span className="mt-1">
                                            {el?.["Agent"]}
                                          </span>
                                        </Checkbox>
                                      </div>
                                    );
                                })}
                              </div>

                              <div className=" pt-2 d-flex justify-content-between">
                                <Button
                                  onClick={() => onReset("user_name")}
                                  className="btn_Clear mr-2"
                                >
                                  Reset
                                </Button>
                                <div>
                                  {/* <Button
                                    //type="link"
                                    onClick={() => close()}
                                    className="btn_Clear cursor-pointer mr-15"
                                  >
                                    Cancel
                                  </Button> */}
                                  <Button
                                    onClick={() => onFilter("user_name")}
                                    className="ant-btn-primary_blue cursor-pointer  "
                                  >
                                    Filter
                                  </Button>
                                </div>
                              </div>
                            </div>
                          }
                          title={false}
                          trigger="click"
                          placement="bottomLeft"
                          visible={filterObject?.["user_name"]?.visible}
                          onVisibleChange={(e) => onVisible(e, "user_name")}

                          //overlayClassName={authParams?.theme_type==="1"?"darkTheme":'lightTheme'}
                        >
                          <SearchOutlined
                            onClick={(e) => {
                              onVisible(null, "user_name");
                            }}
                            className="ml-2 mt-1"
                            style={{
                              color: finalFilters?.["user_name"]?.value
                                ? "#185edf"
                                : "#6c757d",
                            }}
                          />
                        </Popover>
                      )}
                      {col?.column_key === "CurrentLogInStatus" && (
                        <Popover
                          content={
                            <div className="p-15">
                              {Object.entries(current_status_map?.STATUS)?.map(
                                (el) => {
                                  return (
                                    <div className="d-flex justify-content-between">
                                      <Checkbox
                                        onChange={(e) =>
                                          onCheckboxChange(e, "current_status")
                                        }
                                        checked={filterObject?.[
                                          "current_status"
                                        ]?.filterArray?.includes(el?.[0])}
                                        value={el?.[0]}
                                      >
                                        <span className="mt-1">{el?.[1]}</span>
                                      </Checkbox>
                                    </div>
                                  );
                                }
                              )}
                              <div className=" pt-2  d-flex justify-content-between">
                                <Button
                                  onClick={() => onReset("current_status")}
                                  className="btn_Clear mr-2"
                                >
                                  Reset
                                </Button>

                                <Button
                                  onClick={() => onFilter("current_status")}
                                  className="ant-btn-primary_blue cursor-pointer  "
                                >
                                  Filter
                                </Button>
                              </div>
                            </div>
                          }
                          title={false}
                          trigger="click"
                          placement="bottomRight"
                          visible={filterObject?.["current_status"]?.visible}
                          onVisibleChange={(e) =>
                            onVisible(e, "current_status")
                          }

                          //overlayClassName={authParams?.theme_type==="1"?"darkTheme":'lightTheme'}
                        >
                          <FilterOutlined
                            onClick={() => {
                              onVisible(null, "current_status");
                            }}
                            className="ml-2 mt-1"
                            style={{
                              color: finalFilters?.["current_status"]?.value
                                ? "#185edf"
                                : "#6c757d",
                            }}
                          />
                        </Popover>
                      )}
                      {col?.column_key === "StatusSinceinSeconds" && (
                        <Popover
                          content={
                            <div className="p-15">
                              <div className="text_heading font-weight-bold">
                                Older Than
                              </div>
                              {Object.entries(status_duration_map)?.map(
                                (el) => {
                                  return (
                                    <div className="d-flex justify-content-between">
                                      <Radio.Group
                                        onChange={(e) =>
                                          onRadioChange(e, "status_duration")
                                        }
                                        value={
                                          filterObject?.["status_duration"]
                                            ?.filterArray?.[0]
                                        }
                                      >
                                        <Radio value={el?.[0]}>
                                          {" "}
                                          <span className="mt-1">
                                            {el?.[1]}
                                          </span>
                                        </Radio>
                                      </Radio.Group>
                                    </div>
                                  );
                                }
                              )}

                              <div className=" pt-2  d-flex justify-content-between">
                                <Button
                                  onClick={() => onReset("status_duration")}
                                  className="btn_Clear mr-2"
                                >
                                  Reset
                                </Button>

                                <Button
                                  onClick={() => onFilter("status_duration")}
                                  className="ant-btn-primary_blue cursor-pointer  "
                                >
                                  Filter
                                </Button>
                              </div>
                            </div>
                          }
                          title={false}
                          trigger="click"
                          placement="bottomRight"
                          visible={filterObject?.["status_duration"]?.visible}
                          onVisibleChange={(e) =>
                            onVisible(e, "status_duration")
                          }

                          //overlayClassName={authParams?.theme_type==="1"?"darkTheme":'lightTheme'}
                        >
                          <FilterOutlined
                            onClick={() => {
                              onVisible(null, "status_duration");
                            }}
                            className="ml-2 mt-1"
                            style={{
                              color: finalFilters?.["status_duration"]?.value
                                ? "#185edf"
                                : "#6c757d",
                            }}
                          />
                        </Popover>
                      )}
                      {col?.column_key === "PendingCount" && (
                        <Popover
                          content={
                            <div className="p-15">
                              <span>
                                Min
                                <Input
                                  type="number"
                                  style={{ width: "9rem" }}
                                  defaultValue={0}
                                  placeholder="0"
                                  onChange={(e) =>
                                    onIntChange(
                                      e.target.value,
                                      "tickets_in_queue",
                                      "min"
                                    )
                                  }
                                  value={
                                    filterObject?.["tickets_in_queue"]
                                      ?.filterArray?.[0]
                                  }
                                  className="ml-2 mr-2"
                                />
                                Max
                                <Input
                                  type="number"
                                  style={{ width: "9rem" }}
                                  defaultValue={col.max}
                                  placeholder={col?.max}
                                  onChange={(e) =>
                                    onIntChange(
                                      e.target.value,
                                      "tickets_in_queue",
                                      "max"
                                    )
                                  }
                                  value={
                                    filterObject?.["tickets_in_queue"]
                                      ?.filterArray?.[1]
                                  }
                                  className="ml-2 "
                                />
                              </span>
                              <Slider
                                range
                                min={1}
                                max={col.max}
                                defaultValue={[0, col.max]}
                                onAfterChange={(e) =>
                                  onIntChange(e, "tickets_in_queue")
                                }
                                onChange={(e) =>
                                  onIntChange(e, "tickets_in_queue")
                                }
                                value={
                                  filterObject?.["tickets_in_queue"]
                                    ?.filterArray?.length
                                    ? filterObject?.["tickets_in_queue"]
                                        ?.filterArray
                                    : [0, col.max]
                                }
                              />
                              <div className=" pt-2  d-flex justify-content-between">
                                <Button
                                  onClick={() => onReset("tickets_in_queue")}
                                  className="btn_Clear mr-2"
                                >
                                  Reset
                                </Button>

                                <Button
                                  onClick={() =>
                                    onFilter("tickets_in_queue", col)
                                  }
                                  className="ant-btn-primary_blue cursor-pointer  "
                                >
                                  Filter
                                </Button>
                              </div>
                            </div>
                          }
                          title={false}
                          trigger="click"
                          placement="bottomRight"
                          visible={filterObject?.["tickets_in_queue"]?.visible}
                          onVisibleChange={(e) =>
                            onVisible(e, "tickets_in_queue")
                          }

                          //overlayClassName={authParams?.theme_type==="1"?"darkTheme":'lightTheme'}
                        >
                          <FilterOutlined
                            onClick={() => {
                              onVisible(null, "tickets_in_queue");
                            }}
                            className="ml-2 mt-1"
                            style={{
                              color: finalFilters?.["tickets_in_queue"]?.value
                                ? "#185edf"
                                : "#6c757d",
                            }}
                          />
                        </Popover>
                      )}
                      {col?.column_key === "UnActioned" && (
                        <Popover
                          content={
                            <div className="p-15">
                              <span>
                                Min
                                <Input
                                  type="number"
                                  style={{ width: "9rem" }}
                                  defaultValue={0}
                                  placeholder="0"
                                  onChange={(e) =>
                                    onIntChange(
                                      e.target.value,
                                      "unactioned_queue",
                                      "min"
                                    )
                                  }
                                  value={
                                    filterObject?.["unactioned_queue"]
                                      ?.filterArray?.[0]
                                  }
                                  className="ml-2 mr-2"
                                />
                                Max
                                <Input
                                  type="number"
                                  style={{ width: "9rem" }}
                                  defaultValue={col.max}
                                  placeholder={col?.max}
                                  onChange={(e) =>
                                    onIntChange(
                                      e.target.value,
                                      "unactioned_queue",
                                      "max"
                                    )
                                  }
                                  value={
                                    filterObject?.["unactioned_queue"]
                                      ?.filterArray?.[1]
                                  }
                                  className="ml-2 "
                                />
                              </span>
                              <Slider
                                range
                                min={1}
                                max={col.max}
                                defaultValue={[0, col.max]}
                                trackStyle={{ backgroundColor: "#185edf" }}
                                handleStyle={{ borderColor: "#185edf" }}
                                onAfterChange={(e) =>
                                  onIntChange(e, "unactioned_queue")
                                }
                                onChange={(e) =>
                                  onIntChange(e, "unactioned_queue")
                                }
                                value={
                                  filterObject?.["unactioned_queue"]
                                    ?.filterArray?.length
                                    ? filterObject?.["unactioned_queue"]
                                        ?.filterArray
                                    : [0, col.max]
                                }
                              />
                              <div className=" pt-2  d-flex justify-content-between">
                                <Button
                                  onClick={() => onReset("unactioned_queue")}
                                  className="btn_Clear mr-2"
                                >
                                  Reset
                                </Button>

                                <Button
                                  onClick={() =>
                                    onFilter("unactioned_queue", col)
                                  }
                                  className="ant-btn-primary_blue cursor-pointer  "
                                >
                                  Filter
                                </Button>
                              </div>
                            </div>
                          }
                          title={false}
                          trigger="click"
                          placement="bottomRight"
                          visible={filterObject?.["unactioned_queue"]?.visible}
                          onVisibleChange={(e) =>
                            onVisible(e, "unactioned_queue")
                          }

                          //overlayClassName={authParams?.theme_type==="1"?"darkTheme":'lightTheme'}
                        >
                          <FilterOutlined
                            onClick={() => {
                              onVisible(null, "unactioned_queue");
                            }}
                            className="ml-2 mt-1"
                            style={{
                              color: finalFilters?.["unactioned_queue"]?.value
                                ? "#185edf"
                                : "#6c757d",
                            }}
                          />
                        </Popover>
                      )}
                      {col?.column_key === "OldestTicketSince" && (
                        <Popover
                          content={
                            <div className="p-15">
                              <div className="text_heading font-weight-bold">
                                Older Than
                              </div>
                              {Object.entries(oldest_ticket_map)?.map((el) => {
                                return (
                                  <div className="d-flex justify-content-between">
                                    <Radio.Group
                                      onChange={(e) =>
                                        onRadioChange(e, "oldest_ticket_since")
                                      }
                                      value={
                                        filterObject?.["oldest_ticket_since"]
                                          ?.filterArray?.[0]
                                      }
                                    >
                                      <Radio value={el?.[0]}>
                                        {" "}
                                        <span className="mt-1">{el?.[1]}</span>
                                      </Radio>
                                    </Radio.Group>
                                  </div>
                                );
                              })}
                              <div className="d-flex align-items-center mt-1">
                                <Input
                                  type="number"
                                  //placeholder={`Search ${dataIndex}`}
                                  placeholder="0"
                                  className="mr-2 form-control text_regular border-color border-radius-4"
                                  style={{ width: "9rem", height: "4rem" }}
                                  maxLength={50}
                                  value={
                                    filterObject?.["oldest_ticket_since"]
                                      ?.inputVal
                                  }
                                  onChange={(e) =>
                                    onSelectChange(
                                      e.target.value,
                                      "oldest_ticket_since",
                                      "int"
                                    )
                                  }
                                />
                                <Select
                                  style={{ width: "10rem", height: "auto" }}
                                  onChange={(e) =>
                                    onSelectChange(
                                      e,
                                      "oldest_ticket_since",
                                      "select"
                                    )
                                  }
                                  value={
                                    filterObject?.["oldest_ticket_since"]
                                      ?.selectedVal
                                  }
                                  className="font-size14 mb-0 customDate_select border-radius-4"
                                  placeholder="Days"
                                  dropdownClassName={
                                    authParams?.theme_type === "1"
                                      ? "darkTheme"
                                      : "lightTheme"
                                  }
                                  options={[
                                    { value: "days", label: "Days" },
                                    { value: "weeks", label: "Weeks" },
                                    { value: "months", label: "Months" },
                                    { value: "years", label: "Years" },
                                  ]}
                                >
                                  Days
                                </Select>
                              </div>
                              <div className=" pt-2  d-flex justify-content-between">
                                <Button
                                  onClick={() => onReset("oldest_ticket_since")}
                                  className="btn_Clear mr-2"
                                >
                                  Reset
                                </Button>

                                <Button
                                  onClick={() =>
                                    onFilter("oldest_ticket_since")
                                  }
                                  className="ant-btn-primary_blue cursor-pointer  "
                                >
                                  Filter
                                </Button>
                              </div>
                            </div>
                          }
                          title={false}
                          trigger="click"
                          placement="bottomRight"
                          visible={
                            filterObject?.["oldest_ticket_since"]?.visible
                          }
                          onVisibleChange={(e) =>
                            onVisible(e, "oldest_ticket_since")
                          }

                          //overlayClassName={authParams?.theme_type==="1"?"darkTheme":'lightTheme'}
                        >
                          <FilterOutlined
                            onClick={() => {
                              onVisible(null, "oldest_ticket_since");
                            }}
                            className="ml-2 mt-1"
                            style={{
                              color: finalFilters?.["oldest_ticket_since"]
                                ?.value
                                ? "#185edf"
                                : "#6c757d",
                            }}
                          />
                        </Popover>
                      )}
                    </span>
                  );
                }}
                dataIndex={col?.title}
                key={i}
                render={(value, obj) => {
                  return (
                    <span
                      key={value}
                      style={{ maxWidth: "50rem" }}
                      className={
                        i === 0
                          ? "d-flex align-items-center word-wrap"
                          : "word-wrap"
                      }
                    >
                      {i === 0 && (
                        <span
                          className="d-none"
                          style={{
                            width: "1rem",
                            height: "1rem",
                            borderRadius: "50%",
                            display: "inline-block",
                            marginRight: "1rem",
                            backgroundColor: "red",
                          }}
                        />
                      )}
                      {metadata?.chart?.chart_settings?.user_deepdive_columns?.includes(
                        col?.title
                      ) ? (
                        <div className="font-weight600">
                          {shareBrands ? (
                            shareableLinkDeepDiveStatus ? (
                              <span
                                className="cursor-pointer"
                                style={{
                                  color: "#185edf",
                                  textDecoration: "underline",
                                }}
                                onClick={() => {
                                  handleShowTreands(obj);
                                }}
                              >
                                {value?.toLocaleString()}
                              </span>
                            ) : (
                              value?.toLocaleString()
                            )
                          ) : !["create-dashboard", "edit-dashboard"]?.includes(
                              getWindowLocationPath()
                            ) ? (
                            <span
                              className={`${!preview ? "cursor-pointer" : ""}`}
                              style={
                                !preview
                                  ? {
                                      color: "#185edf",
                                      textDecoration: "underline",
                                    }
                                  : {}
                              }
                              onClick={() => !preview && handleShowTreands(obj)}
                            >
                              {value?.toLocaleString()}
                            </span>
                          ) : (
                            value?.toLocaleString()
                          )}
                        </div>
                      ) : metadata?.chart?.chart_settings?.deep_linking_columns?.includes(
                          col?.title
                        ) ? (
                        <span
                          className={`cursor-pointer mr-2`}
                          onClick={() => {
                            onExternal(value, obj?.["Brand ID"]);
                          }}
                          style={{
                            color: "#185edf",
                            // textDecoration: "underline",
                          }}
                        >
                          <Tooltip title="Ticket Details">{value}</Tooltip>
                        </span>
                      ) : col?.column_key === "CurrentLogInStatus" ||
                        col?.title === "Current Status" ? (
                        <>
                          <img
                            src={current_status_map?.ICON?.[value]}
                            alt={current_status_map?.STATUS?.[value]}
                          />
                          <span
                            className="ml-2 "
                            style={{
                              color: current_status_map?.COLOR?.[value],
                            }}
                          >
                            {current_status_map?.STATUS?.[value]}
                          </span>
                        </>
                      ) : col?.column_key === "StatusSinceinSeconds" ||
                        col?.column_key === "OldestTicketSince" ? (
                        <>{SecondstoHumanReadable(value, true, 3)}</>
                      ) : col?.column_key === "OldestTicketID" ? (
                        <div
                          className={`${
                            obj?.[`Oldest Ticket Since`] > 0 ||
                            obj?.[`Oldest Tickets in queue`] > 0
                              ? ""
                              : "disable"
                          } cursor-pointer mr-2`}
                          onClick={() => {
                            config1?.config1?.app_id === "6" &&
                              onExternal(value, obj?.["Brand ID"]);
                          }}
                        >
                          <Tooltip
                            title={
                              config1?.config1?.app_id === "6"
                                ? "Ticket Details"
                                : "Ticket Details open when you're logged in from CX."
                            }
                          >
                            <img
                              src={deepLinkIcon}
                              className="cardList__footer-label"
                              alt="Deep Link Icon"
                              style={{ maxWidth: "1.8rem", width: "1.8rem" }}
                            />
                          </Tooltip>
                        </div>
                      ) : col?.column_key === "UserName" ? (
                        <div className="font-weight600">
                          {shareBrands ? (
                            shareableLinkDeepDiveStatus ? (
                              <span
                                className="cursor-pointer"
                                style={{
                                  color: "#185edf",
                                  textDecoration: "underline",
                                }}
                                onClick={() => {
                                  handleShowTreands(obj);
                                }}
                              >
                                {value?.toLocaleString()}
                              </span>
                            ) : (
                              value?.toLocaleString()
                            )
                          ) : !["create-dashboard", "edit-dashboard"]?.includes(
                              getWindowLocationPath()
                            ) ? (
                            <span
                              className={`${!preview ? "cursor-pointer" : ""}`}
                              style={
                                !preview
                                  ? {
                                      color: "#185edf",
                                      textDecoration: "underline",
                                    }
                                  : {}
                              }
                              onClick={() => !preview && handleShowTreands(obj)}
                            >
                              <>{value?.toLocaleString()}</>
                            </span>
                          ) : (
                            value?.toLocaleString()
                          )}
                        </div>
                      ) : (
                        <>{value?.toLocaleString()}</>
                      )}
                    </span>
                  );
                }}
                showSorterTooltip={null} //soting tooltip
                sortDirections={["ascend", "descend"]}
                sorter={PdfDownloadStatus ? null : col?.sorter}
              />
            );
        })}
      </Table>
      {deepLinkModal?.modalShow && (
        <Modal
          title={null}
          visible={deepLinkModal?.modalShow}
          style={{ width: "100%", top: "1rem", paddingBottom: "1rem" }}
          onOk={handleDeepLinkOk}
          onCancel={handleDeepLinkCancel}
          width="100%"
          footer={null}
          className={`deepLinkModal ${
            authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
          }`}
        >
          {!deepLinkModal?.url ? (
            <div
              className="loader mx-auto"
              style={{ height: "calc(100vh - 2.6rem)" }}
            >
              <div className="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          ) : (
            deepLinkModal?.url
          )}
        </Modal>
      )}
    </div>
  ) : (
    <NoGraphData errorCode="No data found" />
  );
};

export default React.memo(RealtimeGrid, isEqual);
